import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedDate, getSelectedService, getTimetable } from '../../store/selectors';
import { GroupInput } from '../../../components/GroupInput/GroupInput';
import '../../../features/filters/filters.scss';
import { selectDate, setBookingError } from '../../store/serviceSlice';

const filters = require('b_')
    .with('filters');

export const DateSelector = () => {
    const date = useSelector(getSelectedDate);
    const timetable = useSelector(getTimetable);
    const selected = useSelector(getSelectedService);
    const dispatch = useDispatch();
    const onDateSelect = (d) => {
        dispatch(setBookingError(''));
        dispatch(selectDate(d));
    };

    return <div className={filters()} style={{ marginTop: 24 }}>
        <GroupInput
            id="filter_date"
            type="datePicker"
            label="Дата"
            onChange={onDateSelect}
            value={date}
            highlightedDates={timetable}
            highlightDates={!!selected?.selected?.doctors}
        />
    </div>;
};
